import React from 'react'

const Manual_admin_roles_ipad = () => {
  return (
    <>
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
        <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Admin - Roles de iPad
        </h2>
        <p className="text-lg text-gray-700 mb-6">
        La guía explica cómo administrar roles de usuario en iPads, permitiendo crear y editar roles,
        configurar permisos y establecer límites. Ayuda a mejorar la seguridad y funcionalidad, facilitando la
        personalización del acceso según las necesidades.
        </p>
        <iframe
        src="https://scribehow.com/embed/Admin__Roles_de_iPad__I4BcsWzRR1-1dlhvdT_noA?as=scrollable"
        className="scribe-iframe-general-24"
        width="100%"
        height="5100"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
        ></iframe>
        </div>
    </div>
    </>
  )
}

export default Manual_admin_roles_ipad